import { atom } from 'jotai';
import { ModuleType } from '~/utils/module-type';

export const $CurrentPageModule = atom<ModuleType>('' as ModuleType);
